import React from 'react';
import LegalPageLayout from './LegalPageLayout';

function ContactPage() {
	return (
		<LegalPageLayout title="Contact Us">
			<p>
				Need help or have feedback? Reach us anytime at{' '}
				<a href="mailto:contact@moviequotesguesser.com">contact@moviequotesguesser.com</a>.
			</p>
			<h2>What to Include</h2>
			<ul>
				<li>The page you were on and what you expected to happen.</li>
				<li>Your browser and device information, if relevant.</li>
				<li>Screenshots or recordings when possible.</li>
			</ul>
			<p>We aim to respond within a couple of business days.</p>
		</LegalPageLayout>
	);
}

export default ContactPage;
